import React, { useRef, useState } from 'react';
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { Form, Button, message, Skeleton, Row, Col } from 'antd';
import { procesarPreNominaGlobal } from '../../../../apis/ProcesoPreNominaApi';
import AnioPreNomina from '../../../../components/forms/anio_prenomina';
import { status_prenomina } from '../../../../constants/prenomina';
import Result from './result';

const routes = [
  {
    href: '',
    title: (
      <>
        <HomeOutlined />
        <span>Inicio</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Asistencia</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Procesos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Pre-Nómina Global</span>
      </>
    ),
  },
];

const ProcesarPreNominaGlobal = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [objectSelected, setObjectSelected] = useState(null);
  const [disabledForm, setDisabled] = useState(true);
  const [header, setHeader] = useState(null);
  const [status, setStatus] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const anioPrenominaRef = useRef(null);

  const handleOk = async () => {
    setLoading(true);
    try {
      const fields = form.getFieldsValue();
      const payload = {
        periodo_id: fields.periodo_id,
        anio: fields.anio,
        num_periodo: fields.num_periodo,
      };

      const response = await procesarPreNominaGlobal(payload);
      if (response.ok) {
        await anioPrenominaRef.current?.refreshStatus?.();
        message.success('Se procesó correctamente la pre-nómina global');
        setRefreshKey((prev) => prev + 1);
      }
    } finally {
      setLoading(false);
    }
  };

  const onBlurHeader = async (values, dataPeriod, currentStatus) => {
    setHeader(values);
    if (values?.anio && values?.num_periodo && values?.periodo_id) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
    setStatus(currentStatus?.value);
  };

  return (
    <PageApp routes={routes} title={'Procesar Pre-Nómina Global'}>
      <AnioPreNomina
        ref={anioPrenominaRef}
        onBlur={onBlurHeader}
        form={form}
        disabledForm={objectSelected && objectSelected.id > 0}
      />
      <Row gutter={16} className="mt-4 mb-4">
        <Col>
          <Button
            type="primary"
            onClick={handleOk}
            loading={loading}
            disabled={status && (status >= status_prenomina.cerrada)}
          >
            {loading ? 'Procesando' : 'Procesar Todos'}
          </Button>
        </Col>
      </Row>
      <br />
      {loading ? (
        <Skeleton active={loading} />
      ) : (
        <>
          {header && !disabledForm && <Result header={header} refreshKey={refreshKey} />}
        </>
      )}
    </PageApp>
  );
};

export default ProcesarPreNominaGlobal;
